import { render } from "./PageFormDataAnak.vue?vue&type=template&id=640fbf1a"
import script from "./PageFormDataAnak.vue?vue&type=script&lang=js"
export * from "./PageFormDataAnak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__